<script setup>
</script>

<template>
  <!-- ---------------------------------------------- -->
  <!-- searchbar -->
  <!-- ---------------------------------------------- -->
  <v-text-field persistent-placeholder placeholder="Ctrl + k" color="primary" variant="outlined" hide-details density="compact" autocomplete="off">
    <template v-slot:prepend-inner>
      <v-icon size="small" color="lightText">mdi-magnify</v-icon>
    </template>
  </v-text-field>
</template>
